// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perfil-page {
  min-height: calc(100vh - 5.5rem);
  background: var(--bg-page);
  padding: 2rem;
}

.perfil-page .perfil-container {
  max-width: 1400px;
  margin: 0 auto;
}

.perfil-page .perfil-header {
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  color: #ffffff;
  box-shadow: var(--shadow-md);
  margin-bottom: 2rem;
}

.perfil-page .perfil-header .header-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border: 4px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.perfil-page .perfil-header .header-icon i {
  font-size: 3rem;
  color: #ffffff;
}

/* Profile Image Container */
.perfil-page .profile-image-container {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border: 4px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.perfil-page .profile-image-container:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}

.perfil-page .profile-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.perfil-page .profile-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.perfil-page .profile-image-placeholder i {
  font-size: 3.5rem;
  color: #ffffff;
}

.perfil-page .profile-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.perfil-page .profile-image-container:hover .profile-image-overlay {
  opacity: 1;
}

.perfil-page .profile-image-overlay i {
  font-size: 1.8rem;
  color: #ffffff;
  margin-bottom: 0.3rem;
}

.perfil-page .profile-image-overlay span {
  font-size: 0.75rem;
  color: #ffffff;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.perfil-page .profile-image-loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.perfil-page .perfil-title {
  color: #ffffff;
  font-size: 2.2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.perfil-page .perfil-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  margin: 0;
  font-weight: 400;
}

.perfil-page .perfil-card {
  background: var(--bg-card);
  border-radius: 16px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  overflow: hidden;
  margin-bottom: 2rem;
}

.perfil-page .section-tabs {
  display: flex;
  background: var(--bg-card);
  border-bottom: 2px solid var(--border-color);
  padding: 0 2rem;
}

.perfil-page .section-tab {
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  color: #7d8a96;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  top: 2px;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
}

.perfil-page .section-tab:hover {
  color: var(--theme-primary);
  background: var(--theme-primary-soft);
}

.perfil-page .section-tab.active {
  color: var(--theme-primary);
  border-bottom-color: var(--theme-primary);
  font-weight: 600;
}

.perfil-page .section-content {
  padding: 2rem;
}

.perfil-page .data-section {
  margin-bottom: 2rem;
}

.perfil-page .data-section:last-child {
  margin-bottom: 0;
}

.perfil-page .section-title {
  color: var(--text-primary);
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0;
  border-bottom: none;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: none;
  padding: 0;
}

.perfil-page .section-title i {
  color: var(--theme-primary);
  font-size: 1.15rem;
}

.perfil-page .info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}

.perfil-page .info-item {
  background: var(--bg-card);
  padding: 1.25rem;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  display: block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.perfil-page .info-item:hover {
  border-color: var(--theme-primary);
  box-shadow: 0 4px 12px var(--theme-primary-soft);
  transform: translateY(-2px);
}

.perfil-page .info-label {
  color: var(--theme-primary);
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 0.6rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.perfil-page .info-label i {
  color: var(--theme-primary);
  font-size: 0.95rem;
}

.perfil-page .info-value {
  color: var(--text-primary);
  font-size: 1.05rem;
  font-weight: 500;
  word-break: break-word;
  line-height: 1.4;
}

.perfil-page .perfil-badge {
  display: inline-block;
  padding: 0.4rem 1rem;
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
  color: #ffffff;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 6px var(--theme-primary-soft);
}

.perfil-page .perfil-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.perfil-page .p-button {
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.perfil-page .p-button.p-button-outlined.p-button-success {
  border: 2px solid var(--theme-primary);
  color: var(--theme-primary);
  background: transparent;
}

.perfil-page .p-button.p-button-outlined.p-button-success:hover {
  background: var(--theme-primary);
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.perfil-page .p-button.p-button-outlined.p-button-success:active {
  transform: translateY(0);
}

/* Estilos para los diálogos personalizados */
.custom-profile-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.custom-profile-dialog .p-dialog-header {
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
  color: #ffffff;
  border-radius: 0;
  padding: 1.5rem 2rem;
  border: none;
}

.custom-profile-dialog .p-dialog-header .p-dialog-title {
  font-weight: 600;
  font-size: 1.25rem;
  color: #ffffff;
}

.custom-profile-dialog .p-dialog-header .p-dialog-header-icon {
  color: rgba(255, 255, 255, 0.8);
  width: 2.5rem;
  height: 2.5rem;
  transition: all 0.2s ease;
}

.custom-profile-dialog .p-dialog-header .p-dialog-header-icon:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.custom-profile-dialog .p-dialog-content {
  padding: 2rem 2rem 1rem 2rem;
  background: var(--bg-card);
  color: var(--text-primary);
}

.custom-profile-dialog .p-dialog-footer {
  padding: 1.5rem 2rem;
  background: var(--bg-page);
  border-radius: 0;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.custom-profile-dialog .field {
  margin-bottom: 1.5rem;
}

.custom-profile-dialog .p-inputtext {
  border-radius: 8px;
  padding: 0.85rem 1rem 0.85rem 2.5rem;
  /* Space for icon */
  border: 1px solid #d1dce6;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  width: 100%;
}

.custom-profile-dialog .p-inputtext:enabled:focus {
  border-color: var(--theme-primary);
  box-shadow: 0 0 0 0.2rem var(--theme-primary-soft);
  outline: none;
}

.custom-profile-dialog label {
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 0.6rem;
  display: block;
  font-size: 0.9rem;
}

.custom-profile-dialog .p-button {
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  min-width: 110px;
}

/* Primary Button (Standard) */
.custom-profile-dialog .p-button:not(.p-button-text):not(.p-button-secondary) {
  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);
  border: none;
  color: #ffffff;
  box-shadow: var(--shadow-sm);
}

.custom-profile-dialog .p-button:not(.p-button-text):not(.p-button-secondary):hover {
  background: linear-gradient(135deg, #357ABD 0%, #2868A8 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(74, 144, 226, 0.3);
}

/* Cancel Button - FIXED VISIBILITY */
.custom-profile-dialog .p-button.p-button-text.p-button-secondary {
  color: var(--text-secondary) !important;
  background: var(--bg-card);
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.custom-profile-dialog .p-button.p-button-text.p-button-secondary:hover {
  background: var(--theme-primary-soft);
  border-color: var(--theme-primary) !important;
  color: var(--theme-primary) !important;
}

/* Icons in inputs */
.custom-profile-dialog .p-input-icon-left>i {
  color: #4A90E2;
  left: 0.75rem;
}

/* Password field styling for change password dialog */
.custom-profile-dialog .password-field-label {
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 0.6rem;
  display: block;
  font-size: 0.9rem;
}

.custom-profile-dialog .password-input-field {
  width: 100%;
}

.custom-profile-dialog .password-input-field .p-inputtext {
  border-radius: 8px;
  padding: 0.85rem 2.8rem 0.85rem 1rem;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  font-size: 0.95rem;
  width: 100%;
}

.custom-profile-dialog .password-input-field .p-inputtext:enabled:focus {
  border-color: var(--theme-primary);
  box-shadow: 0 0 0 0.2rem var(--theme-primary-soft);
  outline: none;
}

.custom-profile-dialog .password-input-field .p-inputtext::placeholder {
  color: #9ca3af;
}

.custom-profile-dialog .p-password-icon {
  color: #7d8a96;
  cursor: pointer;
  transition: color 0.2s ease;
  right: 0.85rem;
}

.custom-profile-dialog .p-password-icon:hover {
  color: #4A90E2;
}`, "",{"version":3,"sources":["webpack://./src/pages/Perfil.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4FAA4F;EAC5F,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,4FAA4F;EAC5F,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4FAA4F;EAC5F,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,4FAA4F;EAC5F,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".perfil-page {\n  min-height: calc(100vh - 5.5rem);\n  background: var(--bg-page);\n  padding: 2rem;\n}\n\n.perfil-page .perfil-container {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.perfil-page .perfil-header {\n  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n  border-radius: 16px;\n  padding: 3rem 2rem;\n  text-align: center;\n  color: #ffffff;\n  box-shadow: var(--shadow-md);\n  margin-bottom: 2rem;\n}\n\n.perfil-page .perfil-header .header-icon {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.perfil-page .perfil-header .header-icon i {\n  font-size: 3rem;\n  color: #ffffff;\n}\n\n/* Profile Image Container */\n.perfil-page .profile-image-container {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  border: 4px solid rgba(255, 255, 255, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.perfil-page .profile-image-container:hover {\n  transform: scale(1.05);\n  border-color: rgba(255, 255, 255, 0.6);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);\n}\n\n.perfil-page .profile-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.perfil-page .profile-image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.perfil-page .profile-image-placeholder i {\n  font-size: 3.5rem;\n  color: #ffffff;\n}\n\n.perfil-page .profile-image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n}\n\n.perfil-page .profile-image-container:hover .profile-image-overlay {\n  opacity: 1;\n}\n\n.perfil-page .profile-image-overlay i {\n  font-size: 1.8rem;\n  color: #ffffff;\n  margin-bottom: 0.3rem;\n}\n\n.perfil-page .profile-image-overlay span {\n  font-size: 0.75rem;\n  color: #ffffff;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.perfil-page .profile-image-loading {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.perfil-page .perfil-title {\n  color: #ffffff;\n  font-size: 2.2rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.perfil-page .perfil-subtitle {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n.perfil-page .perfil-card {\n  background: var(--bg-card);\n  border-radius: 16px;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  margin-bottom: 2rem;\n}\n\n.perfil-page .section-tabs {\n  display: flex;\n  background: var(--bg-card);\n  border-bottom: 2px solid var(--border-color);\n  padding: 0 2rem;\n}\n\n.perfil-page .section-tab {\n  padding: 1.25rem 1.5rem;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  color: #7d8a96;\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  position: relative;\n  top: 2px;\n  background: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n\n.perfil-page .section-tab:hover {\n  color: var(--theme-primary);\n  background: var(--theme-primary-soft);\n}\n\n.perfil-page .section-tab.active {\n  color: var(--theme-primary);\n  border-bottom-color: var(--theme-primary);\n  font-weight: 600;\n}\n\n.perfil-page .section-content {\n  padding: 2rem;\n}\n\n.perfil-page .data-section {\n  margin-bottom: 2rem;\n}\n\n.perfil-page .data-section:last-child {\n  margin-bottom: 0;\n}\n\n.perfil-page .section-title {\n  color: var(--text-primary);\n  font-size: 1.05rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  padding-bottom: 0;\n  border-bottom: none;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  background: none;\n  padding: 0;\n}\n\n.perfil-page .section-title i {\n  color: var(--theme-primary);\n  font-size: 1.15rem;\n}\n\n.perfil-page .info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1rem;\n}\n\n.perfil-page .info-item {\n  background: var(--bg-card);\n  padding: 1.25rem;\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n  display: block;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.perfil-page .info-item:hover {\n  border-color: var(--theme-primary);\n  box-shadow: 0 4px 12px var(--theme-primary-soft);\n  transform: translateY(-2px);\n}\n\n.perfil-page .info-label {\n  color: var(--theme-primary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 0.6rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.perfil-page .info-label i {\n  color: var(--theme-primary);\n  font-size: 0.95rem;\n}\n\n.perfil-page .info-value {\n  color: var(--text-primary);\n  font-size: 1.05rem;\n  font-weight: 500;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.perfil-page .perfil-badge {\n  display: inline-block;\n  padding: 0.4rem 1rem;\n  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n  color: #ffffff;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  box-shadow: 0 2px 6px var(--theme-primary-soft);\n}\n\n.perfil-page .perfil-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.perfil-page .p-button {\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.perfil-page .p-button.p-button-outlined.p-button-success {\n  border: 2px solid var(--theme-primary);\n  color: var(--theme-primary);\n  background: transparent;\n}\n\n.perfil-page .p-button.p-button-outlined.p-button-success:hover {\n  background: var(--theme-primary);\n  color: #ffffff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n.perfil-page .p-button.p-button-outlined.p-button-success:active {\n  transform: translateY(0);\n}\n\n/* Estilos para los diálogos personalizados */\n.custom-profile-dialog {\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n\n.custom-profile-dialog .p-dialog-header {\n  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n  color: #ffffff;\n  border-radius: 0;\n  padding: 1.5rem 2rem;\n  border: none;\n}\n\n.custom-profile-dialog .p-dialog-header .p-dialog-title {\n  font-weight: 600;\n  font-size: 1.25rem;\n  color: #ffffff;\n}\n\n.custom-profile-dialog .p-dialog-header .p-dialog-header-icon {\n  color: rgba(255, 255, 255, 0.8);\n  width: 2.5rem;\n  height: 2.5rem;\n  transition: all 0.2s ease;\n}\n\n.custom-profile-dialog .p-dialog-header .p-dialog-header-icon:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n}\n\n.custom-profile-dialog .p-dialog-content {\n  padding: 2rem 2rem 1rem 2rem;\n  background: var(--bg-card);\n  color: var(--text-primary);\n}\n\n.custom-profile-dialog .p-dialog-footer {\n  padding: 1.5rem 2rem;\n  background: var(--bg-page);\n  border-radius: 0;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.custom-profile-dialog .field {\n  margin-bottom: 1.5rem;\n}\n\n.custom-profile-dialog .p-inputtext {\n  border-radius: 8px;\n  padding: 0.85rem 1rem 0.85rem 2.5rem;\n  /* Space for icon */\n  border: 1px solid #d1dce6;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n  width: 100%;\n}\n\n.custom-profile-dialog .p-inputtext:enabled:focus {\n  border-color: var(--theme-primary);\n  box-shadow: 0 0 0 0.2rem var(--theme-primary-soft);\n  outline: none;\n}\n\n.custom-profile-dialog label {\n  color: var(--text-primary);\n  font-weight: 600;\n  margin-bottom: 0.6rem;\n  display: block;\n  font-size: 0.9rem;\n}\n\n.custom-profile-dialog .p-button {\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  min-width: 110px;\n}\n\n/* Primary Button (Standard) */\n.custom-profile-dialog .p-button:not(.p-button-text):not(.p-button-secondary) {\n  background: linear-gradient(135deg, var(--theme-primary) 0%, var(--theme-primary-dark) 100%);\n  border: none;\n  color: #ffffff;\n  box-shadow: var(--shadow-sm);\n}\n\n.custom-profile-dialog .p-button:not(.p-button-text):not(.p-button-secondary):hover {\n  background: linear-gradient(135deg, #357ABD 0%, #2868A8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(74, 144, 226, 0.3);\n}\n\n/* Cancel Button - FIXED VISIBILITY */\n.custom-profile-dialog .p-button.p-button-text.p-button-secondary {\n  color: var(--text-secondary) !important;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.custom-profile-dialog .p-button.p-button-text.p-button-secondary:hover {\n  background: var(--theme-primary-soft);\n  border-color: var(--theme-primary) !important;\n  color: var(--theme-primary) !important;\n}\n\n/* Icons in inputs */\n.custom-profile-dialog .p-input-icon-left>i {\n  color: #4A90E2;\n  left: 0.75rem;\n}\n\n/* Password field styling for change password dialog */\n.custom-profile-dialog .password-field-label {\n  color: var(--text-primary);\n  font-weight: 600;\n  margin-bottom: 0.6rem;\n  display: block;\n  font-size: 0.9rem;\n}\n\n.custom-profile-dialog .password-input-field {\n  width: 100%;\n}\n\n.custom-profile-dialog .password-input-field .p-inputtext {\n  border-radius: 8px;\n  padding: 0.85rem 2.8rem 0.85rem 1rem;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n  width: 100%;\n}\n\n.custom-profile-dialog .password-input-field .p-inputtext:enabled:focus {\n  border-color: var(--theme-primary);\n  box-shadow: 0 0 0 0.2rem var(--theme-primary-soft);\n  outline: none;\n}\n\n.custom-profile-dialog .password-input-field .p-inputtext::placeholder {\n  color: #9ca3af;\n}\n\n.custom-profile-dialog .p-password-icon {\n  color: #7d8a96;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  right: 0.85rem;\n}\n\n.custom-profile-dialog .p-password-icon:hover {\n  color: #4A90E2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
